import { render, staticRenderFns } from "./MapButtons.vue?vue&type=template&id=bec7ad50&scoped=true&"
import script from "./MapButtons.vue?vue&type=script&lang=js&"
export * from "./MapButtons.vue?vue&type=script&lang=js&"
import style0 from "./MapButtons.vue?vue&type=style&index=0&id=bec7ad50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec7ad50",
  null
  
)

export default component.exports